<template>
  <v-dialog
    :value="value"
    max-width="800px"
    @input="$emit('input', $event)"
  >
    <v-card class="dialog-card">
      <v-card-title style="padding:30px 0 0 0">
        <span class="headline">表示する項目を選択してください</span>
      </v-card-title>
      <v-card-text>
        <v-container
          grid-list-md
          style="padding-right:0"
        >
          <v-layout wrap>
            <v-flex
              v-for="(h,i) in switchHeaders"
              :key="i"
              xs12
              sm6
              md3
            >
              <v-switch
                v-model="h.value"
                :readonly="i===0 && h.value"
                :label="h.text"
                @change="onChange(i,$event)"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      headersList: ['名称', '住所', 'タンク容量 (L)', '残量 (L)', '補給猶予', 'データ取得時刻', 'タンク', '配送頻度', '最終給油日', '最終給油量 (L)']
    }
  },
  computed: {
    ...mapState('list', ['headers']),
    switchHeaders () {
      return this.headersList.map((e, i) => ({
        id: i + 1,
        text: e,
        value: !!this.headers.find(v => v.text === e)
      }))
    }
  },
  methods: {
    doAction () {
      this.switchHeaders.forEach(e => {
        if (this.headers.includes(e.text)) {
          e.value = true
        }
      })
    },
    onChange (i, e) {
      const order = this.switchHeaders.filter(e => e.value).map(e => e.id)
      this.$store.dispatch('list/updateHeaders', order)
    }

  }
}
</script>

<style lang="scss" scoped>
.dialog-card  {
    display: flex!important;
    flex-direction: column;
    align-items: center;
}
 /deep/ .v-dialog:not(.v-dialog--fullscreen) {
    border-radius: 10px;
}
.headline{
  font-size: 20px!important;
  font-weight: 600;
}
</style>
